import { createStyles } from '@/hooks';
import { colors } from '@/theme/colors';

export const useStyles = createStyles(({ scale }) => ({
  root: {
    position: 'relative',
    zIndex: 1,
  },
  trigger: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderWidth: scale(1),
    borderRadius: scale(4),
    borderColor: colors['5'],
    backgroundColor: colors['Backgrounds/Primary'],
    paddingHorizontal: scale(12),
    height: scale({ phone: 44, tablet: 48 }),
    zIndex: 2,
  },
  triggerError: {
    borderColor: colors.Error,
  },
  triggerLabel: {
    flex: 1,
    color: colors['Labels/Primary'],
    marginRight: scale(12),
  },
  triggerPlaceholderLabel: {
    color: colors['5'],
  },
  iconWrapper: {
    width: scale(20),
    height: scale(20),
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalRoot: {
    flex: 1,
  },
  modalBackdrop: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
  },
  modalContentContainer: {
    position: 'absolute',
  },
  contentWrapper: {
    backgroundColor: colors['Backgrounds/Primary'],
    borderRadius: scale(4),
    borderWidth: scale(1),
    borderColor: colors['5'],
    overflow: 'hidden',
  },
  contentScroll: {
    paddingVertical: scale(6),
  },
  item: {
    paddingHorizontal: scale(12),
    paddingVertical: scale(12),
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  itemSelected: {
    backgroundColor: colors['Fills/Tertiary'],
  },
  disabled: {
    opacity: 0.6,
  },
  itemLabel: {
    color: colors['Labels/Primary'],
    flex: 1,
    marginRight: scale(10),
  },
  helperText: {
    marginTop: scale(6),
    color: colors['Labels/Secondary'],
  },
  helperTextError: {
    color: colors.Error,
  },
}));
